import React, { useEffect, useMemo, useState } from "react";
import * as S from "./BarriersList.style";
import ResueltasList from "./components/resueltasList/ResueltasList";
import GeneralView from "./components/generalView/GeneralView";
import PatientBarriersModal from "./components/patientBarriersModal/PatientBarriersModal";
import NewBarrierModal from "./components/newBarrierModal/NewBarrierModal";
import Modal from "../../../../../../../utils/modal";
import Popup from "reactjs-popup";
import FlorenzSelect from "../../../../../../florenzComponents/florenzSelect";
import { useTranslation } from "react-i18next";
import { QUERY_GET_PROCESS_TYPES } from "../../../../../../../graphql/queries/Process";
import { useQuery } from "@apollo/client";
import * as P from "../../../../../../../utils/pipes";
import { Actions } from "../../../../../../../utils/actionsIds";
import useRecordNavigation from "../../../../../../../hooks/useRecordNavigation";
import FlorenzButton from "../../../../../../florenzComponents/florenzButton";
import { QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED } from "../../../../../../../graphql/queries/UserToProcess";
import ZaiaReaction from "../../../../../../zaiaComponents/zaiaReaction";

const ENV = process.env.REACT_APP_ENV;
const logoZaiaEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

const mockPatients = [
  { id: 1, name: "Isabella Torres", phase: "Fase de Journey 4", barriers: 30, img: "https://i.pravatar.cc/150?img=1" },
  { id: 2, name: "Liam Johnson", phase: "Fase de Journey 1", barriers: 15, img: "https://i.pravatar.cc/150?img=11" },
  { id: 3, name: "Ava Martinez", phase: "Fase de Journey 2", barriers: 20, img: "https://i.pravatar.cc/150?img=5" },
  { id: 4, name: "Noah Smith", phase: "Fase de Journey 3", barriers: 10, img: "https://i.pravatar.cc/150?img=8" },
  { id: 5, name: "Mia Brown", phase: "Fase de Journey 5", barriers: 5, img: "https://i.pravatar.cc/150?img=9" },
  { id: 6, name: "Ethan Davis", phase: "Fase de Journey 6", barriers: 12, img: "https://i.pravatar.cc/150?img=12" },
];

const BarriersList = ({inputText}) => {
  const {t, i18n: { language }} = useTranslation("global");
  const { recordAction } = useRecordNavigation(); 
  const [activeToggle, setActiveToggle] = useState("pendientes");
  const [activeStatus, setActiveStatus] = useState("bajo");
  const [selectedPatientBarriers, setSelectedPatientBarriers] = useState(null);
  const [isNewBarrierModalOpen, setIsNewBarrierModalOpen] = useState(false);
  const [newBarrierPatientId, setNewBarrierPatientId] = useState(null);
  const [selectedBarrierId, setSelectedBarrierId] = useState(null);  
  const [filterProgram, setFilterProgram] = useState(null); 
  const [usersList, setUsersList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const { data: processTypes } = useQuery(QUERY_GET_PROCESS_TYPES);

  const loadLimit = 20; 

  const where = 
    ENV === "production"
    ? {
      isAcepted: { _eq: true },
      stageId: { _nin: [
        "enroll", 
        "suspension_esquema_progresion",
        "completo_ciclos_tratamiento_programados", 
        "ReferredToAnotherInstitution", 
        "deceased", 
        "abandono_tratamiento", 
        "tres_contactos_telefonicos_fallidos", 
        "no_continua_seguimiento_decision_paciente",
        "suspension_tratamiento_cambio_esquema",
        "suspension_esquema_toxicidad",
        "Motivos_Otros"
      ] }
    }
    : {
      isAcepted: { _eq: true },
      stageId: { _nin: ["enroll"] }
    };

  if (filterProgram !== null && filterProgram !== undefined) {
    where.processId = { _eq: filterProgram };
  }

  if (inputText && inputText.trim() !== "") {
    const terms = inputText.trim().split(/\s+/);

    where._and = terms.map(term => ({
      _or: [
        { user: { name: { _ilike: `%${term}%` } } },
        { user: { lastname: { _ilike: `%${term}%` } } },
        { user: { email: { _ilike: `%${term}%` } } },
        { user: { documentNumber: { _ilike: `%${term}%` } } },
      ]
    }));
  }

  const { data: userToProcesses, loading: userToProcessesLoading, error: userToProcessesError, fetchMore } = useQuery(
      QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED, 
      { 
        variables: { 
          where,
          limit: loadLimit, 
          offset: 0
        },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true
      },
    );    

    useEffect(() => {
      if (userToProcessesLoading) return;
      if (userToProcesses?.userToProcess) {
        setUsersList(userToProcesses.userToProcess);
        setOffset(userToProcesses.userToProcess.length);
        
        if (userToProcesses.userToProcess.length <= loadLimit) {
          setHasMore(userToProcesses.userToProcess.length === loadLimit);
        }
      }
    }, [userToProcessesLoading, userToProcesses]);

    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore && !userToProcessesLoading && !isFetchingMore) {
        setIsFetchingMore(true);
        fetchMore({
          variables: {
            limit: loadLimit,
            offset: offset,
          },
          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult || fetchMoreResult.userToProcess.length === 0) {
              return prev;
            }

            const existingIds = new Set(prev.userToProcess.map(p => p.id));
            const newItems = fetchMoreResult.userToProcess.filter(p => !existingIds.has(p.id));

            return {
              ...prev,
              userToProcess: [...prev.userToProcess, ...newItems]
            };
          }
        }).then(({ data }) => {
          if (!data || !data.userToProcess || data.userToProcess.length < loadLimit) {
            setHasMore(false);
          }
          setIsFetchingMore(false);
        }).catch(() => {
          setIsFetchingMore(false);
        });
      }
    };

  const renderRiskPopup = () => (
    <S.RiskPopupContainer>
      <div className="popup-risk-level">Nivel de Riesgo de navegación CRÍTICO <span style={{color: '#ff4d4f'}}>⚠️</span></div>
      <div className="popup-score-row">
        <div className="score-texts">
          <div className="points-main">Puntos 8.5 / 10</div>
          <div className="points-sub">(Alerta Inmediata)</div>
        </div>
        <Popup
          trigger={<button className="learn-more-btn">Aprende más</button>}
          position="right center"
          on="hover"
          nested
          contentStyle={{
            background: 'transparent',
            padding: '0',
            border: 'none',
            boxShadow: 'none',
            width: '320px',
            marginLeft: '15px'
          }}
        >
          <S.ScoreExplanationPopup>
            <div className="tooltip-title">
              <span className="icon">❖</span> Sobre puntuación
            </div>
            <div className="tooltip-white-box">
              <h2>Sobre puntuación</h2>
              <div className="divider" />
              <div className="scroll-content">
                <p>Esta escala de 0 a 10 es el estándar del modelo para definir la "agudeza" o nivel de riesgo de navegación. Para asegurar que nunca se pase de 10, el sistema utiliza dos topes matemáticos:</p>
                <p>* Tope del 80% (Severidad): El promedio ponderado de las barreras se normaliza a una escala de 0 a 10 y luego se multiplica por 0.80, aportando máximo 8 puntos.</p>
                <p>* Tope del 20% (Volumen): La cantidad total de barreras se traduce a un puntaje de ajuste (según una tabla de 0 a 10) que se multiplica por 0.20, aportando máximo 2 puntos.</p>
                <p>¿Qué pasa si un paciente tiene 30 barreras? Aunque el número de barreras sea extremo, el sistema le asignará el puntaje máximo de ajuste (10 puntos), que al aplicarle el 20%, solo sumará 2 puntos al total. Esto evita que el sistema se desborde y mantiene a todos los pacientes críticos dentro del rango de 7.6 a 10.0.</p>
              </div>
            </div>
          </S.ScoreExplanationPopup>
        </Popup>
      </div>
      <div className="popup-divider" />
      <div className="popup-desc">
        <strong>Barreras Críticas (Nivel 3):</strong> El paciente
        presenta "Costo de medicamentos" (peso x1.5) y "Distrés NCCN" (peso x1.3) calificados con severidad máxima.
      </div>
    </S.RiskPopupContainer>
  );

  return (
    <S.Container>
      <S.Header>
        <div className="left-side">
          <button 
            className={`toggle-btn ${activeToggle === 'pendientes' ? 'active' : ''}`}
            onClick={() => setActiveToggle("pendientes")}
          >
            Pendientes
          </button>
          <button 
            className={`toggle-btn ${activeToggle === 'resueltas' ? 'active' : ''}`}
            onClick={() => setActiveToggle("resueltas")}
          >
            Resueltas
          </button>
        </div>
        <div className="right-side">
          <div className="select-btn">
            {
              <Popup
                trigger={
                  <div>
                    <FlorenzSelect
                      placeholder={"Todos"}
                      label={"Fase de Journey"}
                      xsSize={true}
                      forWhiteBackgroud={true}
                      // // value={filterStageTypeStatus}
                      // selectionText={
                      //   filterStageTypeStatus?.length > 0 
                      //   ? filterStageTypeStatus?.length + " " + 
                      //     (
                      //       filterStageTypeStatus?.length === 1
                      //         ? t("globally.stageSelected")
                      //         : t("globally.stagesSelected")
                      //     )
                      //   : t("followUp.allStages")
                      // }
                    />                        
                  </div>
                }
                closeOnDocumentClick
                keepTooltipInside
                position={["bottom center"]}
                nested
              >
                {
                  close => (
                    <S.StatusSelector>
                      <div className="header">
                        {/* {t("followUp.programStages")} */}
                        {t("globally.stageTypes")}
                      </div>
                      <div className="list-groups">
                        {
                          <div className="program-group">
                            <div className="group-header">
                              <div className="group-header__select"
                                onClick={() => {
                                  // if(filterStageTypeStatus?.length === groupStageTypeData?.enTypeMedicineStage.length + 1) {
                                  //   removeAllStatesType();
                                  // } else {
                                  //   selectAllStatesType();
                                  // }
                                }}
                              >
                                {
                                  true
                                  ? t("aiNavigator.outcomes.clearSelection")
                                  : t("aiNavigator.outcomes.selectAll")	
                                }
                              </div>
                            </div>
                            <div className="group-stages-list">
                              {
                                [1,2,3,4,5,6].map((type) => {
                                  return (
                                    <div className="group-stage"
                                      key={type.value}
                                      onClick={() => {
                                        // addMedicineTypeItem(type.value);
                                        // recordAction(Actions.AINAVIGATOR.FILTER_PATIENT_PROGRAM_STATUS, null, filterProgram);                                                
                                      }}
                                    >
                                      <i className={`group-stage__check icon ${true ?  "zaia-i-check-box" : "zaia-i-check-box-outline-blank"}`}/>
                                      <div className="group-stage__title">
                                        {type}
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </S.StatusSelector>
                  )
                } 
              </Popup>     
            }
          </div>
          <div className="select-btn">
            <Popup
              trigger={
                <div>
                  <FlorenzSelect
                    placeholder={t("globally.allPrograms")}
                    label={t("globally.program")}
                    xsSize={true}
                    forWhiteBackgroud={true}
                    items={
                      processTypes?.process?.map((item) => ({
                        value: item.id,
                        text: P.dataTranslation(item.processName, language),
                        img: item.img
                      })) || []
                    }
                    value={filterProgram}
                    noDropdown={true}
                  />                        
                </div>
              }
              closeOnDocumentClick
              keepTooltipInside
              position={["bottom center"]}
              nested
            >
              {
                close => (
                  <S.ProgramSelector>
                    <div className="header">
                      <div className="header__label">{t("globally.program")}</div>
                      {/* <div className="header__label">{t("globally.patients")}</div> */}
                    </div>
                    <div className="list-programs">
                      <div className={`program-item ${filterProgram === null && "program-item--actived"}`}
                        onClick={() => {
                          setFilterProgram(null);
                          recordAction(Actions.AINAVIGATOR.FILTER_BARRIERS_PROGRAM);
                          close();
                        }}
                      >
                        <div className="program-item__name">{t("globally.all")}</div>
                        {/* <div className="program-item__quantity">
                          <i className="program-item__icon icon zaia-i-patient-mangement"></i>
                          <div className="program-item__number">{userToProcessesCount?.userToProcess_aggregate.aggregate.count || 0}</div>
                        </div> */}
                      </div>
                      {
                        processTypes?.process.map((item) => {
                          if(item.userToProcesses?.length > 0) {
                            return (                                 
                              <div className={`program-item ${filterProgram === item.id && "program-item--actived"}`}
                                key={item.id}
                                onClick={() => {
                                  setFilterProgram(item.id);
                                  recordAction(Actions.AINAVIGATOR.FILTER_BARRIERS_PROGRAM, null, item.id);
                                  close();
                                }}
                              >
                                <div className="program-item__name">{P.dataTranslation(item.processName, language)}</div>
                                {/* <div className="program-item__quantity">
                                  <i className="program-item__icon icon zaia-i-patient-mangement"></i>
                                  <div className="program-item__number">{item.userToProcesses?.length}</div>
                                </div> */}
                              </div>
                            )
                          }
                        })
                      }
                    </div>
                  </S.ProgramSelector>
                )
              }
            </Popup>     
          </div>
          <div className="button-container">
            <FlorenzButton
              size="s"
              typeStyle={"primary"}
              text={"Nueva Barrera"}
              widthComplete={true}
              onClick={() => {
                setIsNewBarrierModalOpen(true)
              }}
            />
          </div>
          <div className="button-container">
            <FlorenzButton
              size={"s"}
              icon={"zaia-icono-dots-vertical"}
              iconSize={"14px"}
              typeStyle={"outline"}
            />
          </div>
        </div>
      </S.Header>

      <S.MainContent>
        <div className="content-wrapper">
          {activeToggle === "pendientes" && activeStatus === "" && (
            <GeneralView onSelectView={setActiveStatus} />
          )}

          {activeToggle === "pendientes" && activeStatus && (
            <div className="content-wrapper-critico">
              <div className="main-header">
                <div className="title">
                  Pacientes con Riesgo de Navegación Crítico
                </div>
                <div className="subtitle">
                  Pacientes en crisis inminente o con alertas directas que amenazan críticamente la continuidad de su tratamiento
                </div>
                <div className="warning">
                  <i className="warning__icon zaia-i-alert"></i> Es posible que estos pacientes no finalicen el resultado clínico esperado de su tratamiento.
                </div>
              </div>

              <div className="patient-list" onScroll={handleScroll}>
                {usersList.map(item => (
                  <div className="patient-row" key={item.id}
                    onClick={() => setSelectedPatientBarriers(item)}
                  >
                    <div className="patient-info">
                      <img src={item.user?.picture} alt={`${item.user.name} ${item.user.lastname}`} className="avatar" />
                      <span className="name">{`${item.user.name} ${item.user.lastname}`}</span>
                    </div>
                    <div className='program-info'>
                      <div className='program-info__label'>{t("globally.program")}</div>
            
                      <div className='program-info__value'>
                        {P.dataTranslation(item?.process?.processName, language)}
                      </div>
                    </div>
                    <div className="journey">
                      <span className="phase">{"~Fase del Journey 1"}</span>
                      <span className="view-phase">Ver fase de journey</span>
                    </div>
                    <div className="barrier-count">
                      {item.userToBarriers_aggregate.aggregate.count} barreras
                    </div>
                    <Popup
                      trigger={
                        <div>
                          <FlorenzButton
                            size={"s"}
                            text={"Mas informacion"}
                            icon={"zaia-alert"}
                            iconSize={"14px"}
                            typeStyle={"outline"}
                          />
                        </div>
                      }
                      position="left center"
                      on={["hover", "focus"]}
                    >
                      {renderRiskPopup()}
                    </Popup>
                  </div>
                ))}
                {
                  usersList?.length === 0 && !userToProcessesLoading &&
                      <ZaiaReaction
                        zaiaImg={logoZaiaEmpty}
                        text={t("globally.noResults")}
                        subText={t("globally.noMatchingPatients")}
                        sizeText="33.25px"
                        sizeSubText="15px"
                        textColor="var(--blue-color)"
                        widthimg="210px"
                      />
                  }
                  {
                    userToProcessesError && !userToProcessesLoading &&
                      <ZaiaReaction
                        zaiaImg={logoZaiaAlert}
                        sizeText="20px"
                        text={t("globally.genericError")}
                        textColor="var(--blue-color)"
                        widthimg="150px"
                      />
                  }
                  {
                    userToProcessesLoading &&
                      <ZaiaReaction
                        zaiaImg={logoZaiaLoading}
                        sizeText="20px"
                        textColor="var(--blue-color)"
                        widthimg="150px"
                      />
                  }
                  {isFetchingMore && (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                      <ZaiaReaction widthimg="40px" zaiaImg={logoZaiaLoading}/>
                    </div>
                  )} 
              </div>              
            </div>
          )}
          <div className="footer-bar">
            {
              activeStatus !== "" && (
                <FlorenzButton
                  size={"s"}
                  text={"Vista general"}
                  icon={"zaia-icono-atras"}
                  iconSize={"9px"}
                  typeStyle={"secondary"}
                  onClick={() => {
                    setActiveStatus("")
                  }}
                />
              )
            }
            <div className="status-bars">
              {[
                { id: "critico", label: "Crítico", className: "critico" },
                { id: "alto", label: "Alto", className: "alto" },
                { id: "medio", label: "Medio", className: "medio" },
                { id: "bajo", label: "Bajo", className: "bajo" }
              ].map(status => (
                <div 
                  key={status.id}
                  className={`status-pill ${status.className} ${activeStatus === status.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveStatus(status.id)
                  }}
                >
                  {status.label}
                </div>
              ))}
            </div>
          </div>
        </div>

        {activeToggle === "resueltas" && (
          <ResueltasList 
            filterProgram={filterProgram}
            inputText={inputText}
            onOpenReport={(item) => {
              setSelectedBarrierId(item.id);
              setSelectedPatientBarriers({ id: item.userToProcessId });
            }}
          />
        )}
      </S.MainContent>
      <Modal open={!!selectedPatientBarriers || !!selectedBarrierId}>
        <PatientBarriersModal 
          patient={selectedPatientBarriers} 
          barrierId={selectedBarrierId}
          onClose={() => {
            setSelectedPatientBarriers(null);
            setSelectedBarrierId(null);
          }} 
          onOpenNewBarrier={(patientId) => {
            setNewBarrierPatientId(patientId);
            setIsNewBarrierModalOpen(true);
          }}
        />
      </Modal>
      <Modal open={isNewBarrierModalOpen}>
        <NewBarrierModal 
          patientId={newBarrierPatientId} 
          onClose={() => {
            setIsNewBarrierModalOpen(false);
            setNewBarrierPatientId(null);
          }} 
        />
      </Modal>
    </S.Container>
  );
};

export default BarriersList;
